import ProviderList      from '../views/ProviderList';
import ProviderDashboard from '../views/ProviderDashboard';
import { Route }         from 'react-router-dom';

export default [
  <Route key="list" element={<ProviderList />} path="/prestataires" />,
  <Route key="show" element={<ProviderDashboard />} path="/prestataires/:providerId" />,
];
